export default __webpack_public_path__ + "static/coninsa-green-25f30888bf5d9e6ceb44120ca0d80c63.png";